import React, { useState, useCallback, useEffect } from 'react';
import styles from './Preferences.module.scss';
import { CustomButton } from '../../../../components/Button/Button';
import { useUserContext } from '../../../../context/UserContext';
import { useTranslation } from 'react-i18next';
import { PreferencesItem } from '../PreferencesItem/PreferencesItem';
import SelectTransition from '../SelectTransition/SelectTransition';

export const Preferences = () => {
  const { t } = useTranslation();

  /*   const [transitionOptions, setTansitionOptions] = useState([
    t('account.settings.preferences.clip_transitions.no_transition'),
    t('account.settings.preferences.clip_transitions.dip_to_white'),
    t('accountvideoPreferencesContainer.settings.preferences.clip_transitions.dip_to_black'),
  ]);
 */

  const { toggleVideoSetting, resetDefaultSettings, defaultSettings } = useUserContext();

  const resetDefaultSetting = () => {
    resetDefaultSettings();
  };

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.videoPreferencesContainer}>
        <div className={`${styles.preferencesTitle} ${styles.title}`}>{t('account.settings.video_viewer_settings')}</div>
        <p>{t('account.settings.preferences.subtitle')}</p>

        <ul className={styles.listContainer}>
          {defaultSettings.map(item => (
            <PreferencesItem item={item} key={item.setting} toggleSetting={toggleVideoSetting} />
          ))}
        </ul>
        <div className={styles.buttonContainer}>
          <CustomButton
            label={t('account.settings.preferences.btn.reset_settings')}
            variant="secondary"
            onClick={resetDefaultSetting}
          />
        </div>
      </div>

      {/*      
      // First Commented, we can use it later for the Transistions
      <div className={styles.transitionsContainer}>
        <div className={`${styles.preferencesTitle} ${styles.title}`}>{t('account.settings.preferences.clip_transitions')}</div>
        <p>{t('account.settings.preferences.clip_transitions.subtitle')} </p>
        <p>{t('account.settings.preferences.clip_transitions.transitions')} </p>

        <div className={styles.transitionsSettings}>
          <div className={styles.transitionSelector}>
            <SelectTransition id="preferences" large options={options} left data={transitionOptions} onClick={handleOptions} />
          </div>

          <div className={styles.clipTransitionsButton}>
            <CustomButton
              label={t('account.settings.preferences.btn.reset_transitions')}
              variant="secondary"
              onClick={resetToDefault}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};
